function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.0811,20 L1.9191,20 C1.3991,20 0.9671,19.602 0.9241,19.084 L0.0171,4.265 C0.0081,4.122 0.1221,4 0.2661,4 L11.7341,4 C11.8781,4 11.9921,4.122 11.9831,4.265 L11.0761,19.084 C11.0331,19.602 10.6011,20 10.0811,20 Z M11,1 C11.553,1 12,1.448 12,2 L12,2.75 C12,2.888 11.888,3 11.75,3 L0.25,3 C0.112,3 0,2.888 0,2.75 L0,2 C0,1.448 0.447,1 1,1 L4,1 C4,0.448 4.447,0 5,0 L7,0 C7.553,0 8,0.448 8,1 L11,1 Z",
  id: "path-1"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-4 0 20 20"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/trash.45f2e23f.svg";
export { SvgComponent as ReactComponent };